var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 45,
    fill: "url(#pattern0_31_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_31_53",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_53",
    transform: "scale(0.0196078 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_53",
    width: 51,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAtCAYAAAADfVPBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEvElEQVRogdXaSWyVVRQH8N97LYOCDDVCkVAHEExBI0gURxYkitGVU0xcEIdooitITAyJkqiJCyOuWIiistCIQ9wYSTROgBFHXEhRRAtOgWCAloJlaOvifC99vPT1fV/f16b+k+ZLv3fvPed/77nnnHvuV2hra5MR87AAszAua+cUOIpf8QMOZOnYmLLdFXgAd+A0vsc+/JtFWEpchNuxOJGxCRukIFaLzFw8j4V4EUvxSz2aZkADlmAFduEVPIXOah2KVd4XsBJf4jPMxtNGjgj04As8hFY04UfcUK3DQCszButxmVjq9tzVzI79uB+34G08jtcqG1WSKeBVMQtLcWxYVcyOzbgRH6EPG8t/rCSzBi1YjuMjod0QsBvLsA2/YWvph/I9cz0exN1GL5ES9uA+vIFJpZfFsuc6rBL2+X/AZmFuT5ZelMzsTrEab6UZpbW1Na3ACZiBs0V86hCT1ZOmc4qAvho78RwOlMg8mrzIC2NwOc4f4LdTiQJ/5CBnP94Vnu7ZImZiPt7PYXAYi+sEkYPYjg/xsYgTvSKjmJeTvI24hzCzZfgEJ3MafCHOwc/C85SjHX/hWpFdHJEx/xoA20WeOK0oAuPXdQ5YQjOmCYUriZRwMlHgtAjM1bKQtOgRueKiIi4Qri4PXCzMqNbO7U5kniUcRL3YgwuLmIpDOQw4BucKs+lO0X5f8mzOQfZhTCmKFKY3hwGnJs9/UrY/KTLgqbUapkAHJtdrr+UoHdSyZA/H5XjAy5NMaawsq9ybpw55kim59iwzPU5+ISFXMkeT55SU7QuYjK68FMiTTJfwYjOEorUwTQTtg3kpkCcZ2Ctix6wa7QoiA+jD73kJHw4y3eLMPmmQdvOEObZLF5NSIW8yp0S9q1HkX5XRvZRNXyJizE95Ck9bN6uF8SKSTxA517ci4VwsYkmnKB01Jc/D4hiwACeS/w+qM3jXS6ZRmFSL/k1/QqT8n4pcbQamC0U7xB75M3nXUjZWtyD4dz3KDBVjcY3YG4eE/R8SZErKtSV/BbHZy7EfH4jVbBbEr8RE1TPuQVEPmUWCyG5xdhkMlURK6BEm2ClW7GrhHLoMYYWKiaCsjqAZ5wlzqUUkLbrxlXAi8zPqNAmdRbH5mjIKniUmYVfGfrXQLW4AxovJSosmHCmK5Z2TUWiTOPLmFiPKUCp1ZTkazEZ7Ed/gqowCxxoeIsrGTZuwNgjHsaNRVE3WCgXTZrDHhGtdJJ+DXTkmJM+jg7bqxxKxdw80iuLDTtyK91IO8J2YjZkZlEyLvkS5vSnbr8Cb9LvmdXhMejIdojzVIP+U6LTqrrwSzeI2bz4UkhJoUeRUz0hZoh0l2CAmdhX9K9OLR8Ryfa7+wtxIYDlukqwKZ5rINuEINolC92jGHHEpdq+yO85Ke18rLnDeMXoJzRUeeDW2lP8w0OZ9WJjZFnGNPZpws9BrjViZMzAQmVPiiuB1EVBXGp6PF7JgOl7GS7jLAJezVHerfXhBnBaXiVruEyJtGCk0JPLXi2NEhzjMba3WodYRYDdu0/+FxlaRJewQQa1LjqUiUReYIjb4YnEhtUkcAGt62MIQvp25VLjDFpF6TMw6wCA4ov/bmR0yhoj/AE7UDL8uQmLDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerso);
export default __webpack_public_path__ + "static/media/Perso.6691ea55dc0d8ba336d490fa1f470efa.svg";
export { ForwardRef as ReactComponent };